import React from 'react';

import { Box, Link } from '@rover/kibble/core';

// eslint-disable-next-line react/no-unused-prop-types
type FooterLink = { name: string; url: string };

type Props = {
  linkList: FooterLink[];
  numColumns?: number | number[];
};

type FooterLinkListItemProps = { children: React.ReactNode };
const FooterLinkListItem: React.FC<FooterLinkListItemProps> = ({ children }) => (
  <Box webAs="li" py="1x" mb="1x" sx={{ listStyleType: 'none' }}>
    {children}
  </Box>
);

const FooterLinkList: React.FC<Props> = ({ linkList, numColumns = [2, 3, 5] }) => (
  <Box
    webAs="ul"
    role="list"
    p="0x"
    mb={['4x', '4x', '0x']}
    flexBasis="80%"
    sx={{
      columnCount: numColumns,
      columnGap: '24px',
      columnFill: 'balance',
      listStyleType: 'none',
    }}
  >
    {linkList.map(({ name, url }: FooterLink) => {
      return (
        <FooterLinkListItem key={name}>
          <Link size="100" underline={false} variant="secondaryContrast" key={url} href={url}>
            {name}
          </Link>
        </FooterLinkListItem>
      );
    })}
  </Box>
);

export default FooterLinkList;
